import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Billing", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"800px"} }, null, -1)
const _hoisted_3 = { class: "dialog-card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "section-title mb-3" }, "Payments Details", -1)
const _hoisted_5 = { class: "dialog-card" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "section-title mb-2" }, "Referral", -1)
const _hoisted_7 = { style: {"max-width":"440px"} }
const _hoisted_8 = { class: "dialog-card" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "section-title mb-1" }, "Billing History", -1)
const _hoisted_10 = { class: "scroll-content" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "section-title mb-0" }, "Billing Information", -1)
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px"} }, null, -1)

import { onMounted, reactive, ref, watch } from 'vue';
import { useBillingStore } from '@/stores/billing';
import { useAccountStore } from '@/stores/account';
import dayjs from 'dayjs';
import VTabs from '@/components/VTabs.vue'
import VInput from '@/components/VInput.vue';
import VButton from '../VButton.vue';
import PaymentDetails from '@/components/PaymentDetails.vue';
import PaymentMethod from '../PaymentMethod.vue';
import Table from '../Table.vue';
import DownloadIcon from '@/components/icons/actions/DownloadIcon.vue'
import VReferalSuccessLabel from '../VReferalSuccessLabel.vue';
import VCollapse from '../VCollapse.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingInfoDialog',
  props: {
    startPage: null
  },
  setup(__props: any) {

const props = __props as { startPage?: "profile" | "details" }


const billingStore = useBillingStore()
onMounted(() => {
  billingStore.requestAll()
})

const values = reactive({
  full_name: "",
  business_name: "",
  city: "",
  country: "",
  postal_code: "",
  state: ""
})
watch(() => billingStore.cardInfo, (cardInfo) => {
  if (!cardInfo) return
  for (let key in values) {
    (values as any)[key] = (cardInfo as any)[key] || ""
  }
})

const columns = {
  date: { title: "Date", get: (item: any) => dayjs(item.date).format("DD MMM YYYY"), minWidth: 80 },
  invoice_number: { title: "Order", minWidth: 100 },
  currency: { title: "Currency", get: (item: any) => item.currency.toUpperCase() },
  total: { title: "Total" },
  pdf_url: { title: "PDF", width: 20, class: "block-formats" }
}

const referralCode = ref("")
const referralStatus = ref("none")
const referralCount = ref(200)
const accountStore = useAccountStore()
const referralPending = ref(false)

const applyReferral = async () => {
  referralPending.value = true
  try { 
    referralCount.value = await accountStore.applyReferal(referralCode.value)
    referralStatus.value = "success"
  } catch (e: any) {
    if (e.body?.[0]?.message === "Code already use") {
      referralStatus.value = "error-already-use"
      return
    }
    referralStatus.value = "error"
  } finally {
    referralPending.value = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(VTabs, {
      pages: { profile: 'Billing profile', details: 'Billing details' },
      "start-page": props.startPage,
      "with-router": "",
      class: "dialog-tabs billing-dialog"
    }, {
      profile: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(PaymentDetails)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(VInput, {
              modelValue: referralCode.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((referralCode).value = $event)),
              label: "Referral code",
              placeholder: "Enter your code"
            }, {
              append: _withCtx(() => [
                (referralCode.value.length > 0)
                  ? (_openBlock(), _createBlock(VButton, {
                      key: 0,
                      disabled: referralPending.value,
                      class: "v-input__append-button",
                      onClick: applyReferral
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Apply")
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(VReferalSuccessLabel, {
              class: "mt-1",
              status: referralStatus.value,
              count: referralCount.value
            }, null, 8, ["status", "count"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Table, {
              columns: columns,
              data: _unref(billingStore).history,
              loading: !_unref(billingStore).historyLoaded
            }, {
              invoice_number: _withCtx(({ cell}) => [
                _createTextVNode(" Payment"),
                _hoisted_11,
                _createTextVNode(_toDisplayString(cell), 1)
              ]),
              pdf_url: _withCtx(({ cell }) => [
                _createElementVNode("a", {
                  class: "billing-info__download-pdf",
                  href: cell,
                  download: ""
                }, [
                  _createVNode(DownloadIcon)
                ], 8, _hoisted_12)
              ]),
              _: 1
            }, 8, ["data", "loading"])
          ])
        ])
      ]),
      details: _withCtx(() => [
        _createVNode(PaymentMethod),
        _createVNode(VCollapse, { class: "dialog-card billing-information" }, {
          activator: _withCtx(({ opened, toggle }) => [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("a", {
                onClick: toggle,
                class: "ml-auto clickable"
              }, _toDisplayString(opened? "Collapse": "Show"), 9, _hoisted_15)
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_16,
            _createVNode(VInput, {
              disabled: "",
              modelValue: values.full_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((values.full_name) = $event)),
              label: "Full name",
              placeholder: "Enter full name"
            }, null, 8, ["modelValue"]),
            _createVNode(VInput, {
              disabled: "",
              modelValue: values.business_name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((values.business_name) = $event)),
              class: "mt-2",
              label: "Company name",
              placeholder: "Enter company name"
            }, null, 8, ["modelValue"]),
            _createVNode(VInput, {
              disabled: "",
              modelValue: values.country,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((values.country) = $event)),
              class: "mt-2",
              label: "Country",
              placeholder: "Select your country"
            }, null, 8, ["modelValue"]),
            _createVNode(VInput, {
              disabled: "",
              modelValue: values.state,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((values.state) = $event)),
              class: "mt-2",
              label: "State/Province/Territory",
              placeholder: "Your state/province/territory"
            }, null, 8, ["modelValue"]),
            _createVNode(VInput, {
              disabled: "",
              class: "mt-2",
              label: "Address",
              placeholder: "Street or POS"
            }),
            _createVNode(VInput, {
              disabled: "",
              modelValue: values.city,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((values.city) = $event)),
              class: "mt-2",
              label: "City",
              placeholder: "Your city name"
            }, null, 8, ["modelValue"]),
            _createVNode(VInput, {
              disabled: "",
              modelValue: values.postal_code,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((values.postal_code) = $event)),
              class: "mt-2",
              label: "Post code",
              placeholder: "Your post code"
            }, null, 8, ["modelValue"]),
            _createVNode(VInput, {
              disabled: "",
              class: "mt-2",
              label: "VAT number",
              placeholder: "Enter VAT number"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["start-page"])
  ], 64))
}
}

})